import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { showToast } from "../components/ui/toast";

// Version history for prompts and rental prompts. `baseRoute` is the prompt
// collection route (API_ROUTES.GET_PROMPT or API_ROUTES.GET_RENTAL_PROMPT);
// versions live at `${baseRoute}/:id/versions`.
export const promptVersionsQueryKey = (baseRoute, promptId) => [
  baseRoute,
  promptId,
  "versions",
];

export const useGetPromptVersionsQuery = (baseRoute, promptId) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: promptVersionsQueryKey(baseRoute, promptId),
    queryFn: () => api.get(`${baseRoute}/${promptId}/versions`),
    enabled: !!promptId,
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useDeletePromptVersionMutation = (baseRoute) => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, isPending, variables } =
    useMutation({
      mutationFn: ({ promptId, versionId }) =>
        api.delete(`${baseRoute}/${promptId}/versions/${versionId}`),
      onSuccess: () => {
        showToast("success", "Version deleted successfully");
      },
      onError: (err) => {
        showToast(
          "error",
          err?.response?.data?.message || "Failed to delete version"
        );
      },
      onSettled: (_data, _error, { promptId }) => {
        queryClient.invalidateQueries({
          queryKey: promptVersionsQueryKey(baseRoute, promptId),
        });
      },
    });
  return { mutate, isError, error, isSuccess, isPending, variables };
};
